<input
  #radio
  type="radio"
  [attr.name]="radioGroup.name"
  [checked]="checked$ | async"
  [disabled]="isDisabled()"
  class="scale-125 transition duration-300 border cursor-pointer border-gray-200 shadow-inner outline-none !ring-offset-0 !ring-0
  {{ radioGroup.radioClass }}"
/><ng-content></ng-content>
